export default from './post-page-layout';



// WEBPACK FOOTER //
// ./app/components/post-page-layout/index.js